(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (panel) => {
    if (panel.dataset.mdOrbsReady) return;
    panel.dataset.mdOrbsReady = 'true';
    const orbs = panel.querySelector('.md-orbs, .md-mark-art');
    if (!orbs) return;
    const seen = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        panel.classList.add('is-inview');
        seen.disconnect();
      });
    }, { threshold: 0.35 });
    seen.observe(panel);
    if (still) return;
    let frame = 0;
    let px = 0;
    let py = 0;
    const apply = () => {
      frame = 0;
      const box = panel.getBoundingClientRect();
      const scroll = (box.top + box.height / 2 - innerHeight / 2) / innerHeight;
      orbs.style.setProperty('--_px', px.toFixed(3));
      orbs.style.setProperty('--_py', (py + scroll * 1.6).toFixed(3));
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(apply);
    };
    panel.addEventListener('pointermove', (event) => {
      const box = panel.getBoundingClientRect();
      px = ((event.clientX - box.left) / box.width - 0.5) * 2;
      py = ((event.clientY - box.top) / box.height - 0.5) * 2;
      schedule();
    });
    panel.addEventListener('pointerleave', () => {
      px = 0;
      py = 0;
      schedule();
    });
    addEventListener('scroll', schedule, { passive: true });
    apply();
  };
  const run = () => document.querySelectorAll('[data-md-orbs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
